import VueRouter from 'vue-router';
import Dashboard from '../components/sections/Dashboard.vue';
import EditProfile from '../components/sections/settings/EditProfile.vue';
import CampaignList from '../components/sections/campaign/CampaignList.vue';
import Campaign from '../components/sections/campaign/Campaign.vue';
import ProposalList from '../components/sections/proposal/ProposalList.vue';
import Job from '../components/sections/job/Job.vue';
import Deal from '../components/sections/deal/Deal.vue';
import Sponsorships from '../components/sections/Sponsorships.vue';
import PaymentDashboard from '../components/sections/payments/PaymentDashboard.vue';

//v2 routes
import v2Routes from '../../app-v2/routes';
import activationPreviewRoutes from '../../app-v2/routes/activation-preview-routes';
import ManageNetworksRouterView from '../../app-v2/components/router-views/ManageNetworksRouterView.vue';
import InsightsRouterView from '../../app-v2/components/router-views/InsightsRouterView.vue';

/**
 * The VueRouter instance
 *
 * @type {VueRouter}
 */
const router = new VueRouter({
    /**
     * Enable html history mode
     *
     * @type {string}
     */
    mode: 'history',

    /**
     * Save the scroll position
     *
     * @type {boolean}
     */
    saveScrollPosition: true,

    /**
     * The routes
     *
     * @type {array}
     */
    routes: [
        activationPreviewRoutes,
        v2Routes,

        /**
         * The dashboard routes
         */
        {
            path: '/:live_url([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})',
            component: Dashboard,
            children: [
                {
                    path: '',
                    redirect: {
                        name: 'sponsorships'
                    }
                },
                {
                    path: 'dashboard',
                    name: 'sponsorships',
                    component: Sponsorships
                },
                {
                    path: 'profile',
                    name: 'edit.profile',
                    component: EditProfile
                },
                {
                    path: 'campaigns',
                    name: 'campaigns',
                    component: CampaignList
                },
                {
                    path: 'campaigns/:campaign_id',
                    name: 'campaign',
                    component: Campaign
                },
                {
                    path: 'campaigns/:campaign_id/proposals',
                    name: 'proposals',
                    component: ProposalList
                },
                {
                    path: 'job/:proposal_id',
                    name: 'job',
                    component: Job
                },
                {
                    path: 'deal/:id',
                    name: 'deal',
                    component: Deal
                },
                {
                    path: 'networks',
                    name: 'manage.networks',
                    component: ManageNetworksRouterView
                },
                {
                    path: 'insights',
                    name: 'insights',
                    component: InsightsRouterView
                },
                {
                    path: 'payments/dashboard',
                    name: 'payments.dashboard',
                    component: PaymentDashboard
                }
            ]
        },
        {
            path: '/campaigns/:campaign_id/preview',
            component: Campaign
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (from.query.preview && !to.query.preview) {
        to.query.preview = 'true';
        next(to);
    } else {
        next();
    }
});

router.afterEach(() => {
    window.dispatchEvent(new CustomEvent('historystatechange-vue'));
});

(function () {
    const originalPush = router.constructor.prototype.push;

    router.constructor.prototype.push = function push(location, onResolve, onReject) {
        if (onResolve || onReject) {
            return originalPush.call(this, location, onResolve, onReject);
        }

        return originalPush.call(this, location).catch((err) => {
            if (err.name !== 'NavigationDuplicated') {
                throw err;
            }
        });
    };
})();

export default router;
